import styled from 'styled-components'

export const Tabs = styled.div`
  max-width: 100%;
`
